import { render, staticRenderFns } from "./navigation-side-app.component.vue?vue&type=template&id=c650250c&scoped=true"
import script from "./navigation-side-app.component.vue?vue&type=script&lang=js"
export * from "./navigation-side-app.component.vue?vue&type=script&lang=js"
import style0 from "./navigation-side-app.component.vue?vue&type=style&index=0&id=c650250c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c650250c",
  null
  
)

export default component.exports